import React, { useState } from "react";
import { Card, CardContent, TextField, Button } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    root: {
        flexGrow: 1,
    },
    card: {
        minWidth: '80%',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        padding: 20,
    },
    input: {
        marginBottom: 20,
    },
});

const CreateStaff = ({ onAdded }) => {
    const classes = useStyles();

    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");


    const handleCreate = async () => {
        try {
            console.log(localStorage.getItem("token"));
            var myHeaders = new Headers();
            myHeaders.append("Authorization", `Bearer ${localStorage.getItem("token")}`);
            myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
            var urlencoded = new URLSearchParams();
            urlencoded.append("name", name);
            urlencoded.append("address", address);
            urlencoded.append("userID", localStorage.getItem("userID"));
            urlencoded.append("phone", phone);
            urlencoded.append("email", email);
            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: urlencoded,
                redirect: 'follow'
            };
            fetch("http://biometick.com/post-staff", requestOptions)
                .then(response => response.text())
                .then(result => {
                    console.log(result);
                    result = JSON.parse(result);
                    if (result.hasOwnProperty('_id')) {
                        onAdded('read');
                    } else {
                        console.log('Some error occured while saving.');
                    }
                })
                .catch(error => console.log('error', error));

            // add logic to show success message or navigate to location list screen
        } catch (error) {
            console.log(error);
            // add logic to show error message
        }
    };

    return (
        <div className={classes.root} style={{ minWidth: '100%', display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Card className={classes.card}>
                <CardContent>
                    <div style={{ flexDirection: 'row', display: 'flex' }}>
                        <TextField
                            required
                            label="Name"
                            variant="outlined"
                            className={classes.input}
                            fullWidth
                            margin={'10px'}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        <div style={{ width: '10px' }} />
                        <TextField
                            required
                            label="Address"
                            variant="outlined"
                            className={classes.input}
                            fullWidth
                            margin={'10px'}
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                        />
                    </div>
                    <div style={{ flexDirection: 'row', display: 'flex' }}>
                        <TextField
                            required
                            label="Email"
                            variant="outlined"
                            className={classes.input}
                            fullWidth
                            margin={'10px'}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <div style={{ width: '10px' }} />
                        <TextField
                            required
                            label="Phone"
                            variant="outlined"
                            className={classes.input}
                            fullWidth
                            margin={'10px'}
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                    </div>
                    <Button variant="contained" style={{ height: '45px' }} color="primary" fullWidth onClick={handleCreate}>
                        Create Staff
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
};

export default CreateStaff;